import { ActionType, createReducer } from 'typesafe-actions'
import { resetCampaignDataAction } from '@/redux/company/handles/resetCampaignDataAction'
import {
  createLabelHandle,
  deleteLabelHandle,
  fetchLabelsByCompanyAndOperatorHandle,
  updateLabelHandle
} from './handles'
import { LabelState, LabelAction } from './types'

type Action = LabelAction | ActionType<typeof resetCampaignDataAction>

export const initialState: LabelState = {
  labels: [],
  isErrorOnCreateLabel: false,
  isLoadingCreateLabel: false,
  isSuccessOnCreateLabel: false,
  isErrorOnUpdateLabel: false,
  isLoadingUpdateLabel: false,
  isSuccessOnUpdateLabel: false,
  isErrorOnDeleteLabel: false,
  isLoadingDeleteLabel: false,
  isSuccessOnDeleteLabel: false,
  isErrorOnFetchLabelsByCompanyAndOperator: false,
  isLoadingFetchLabelsByCompanyAndOperator: false,
  isSuccessOnFetchLabelsByCompanyAndOperator: false
}

export const labelReducer = createReducer<LabelState, Action>(initialState)
  .handleAction(createLabelHandle.asyncAction.request, createLabelHandle.request)
  .handleAction(createLabelHandle.asyncAction.success, createLabelHandle.success)
  .handleAction(createLabelHandle.asyncAction.failure, createLabelHandle.failure)
  .handleAction(updateLabelHandle.asyncAction.request, updateLabelHandle.request)
  .handleAction(updateLabelHandle.asyncAction.success, updateLabelHandle.success)
  .handleAction(updateLabelHandle.asyncAction.failure, updateLabelHandle.failure)
  .handleAction(deleteLabelHandle.asyncAction.request, deleteLabelHandle.request)
  .handleAction(deleteLabelHandle.asyncAction.success, deleteLabelHandle.success)
  .handleAction(deleteLabelHandle.asyncAction.failure, deleteLabelHandle.failure)
  .handleAction(
    fetchLabelsByCompanyAndOperatorHandle.asyncAction.request,
    fetchLabelsByCompanyAndOperatorHandle.request
  )
  .handleAction(
    fetchLabelsByCompanyAndOperatorHandle.asyncAction.success,
    fetchLabelsByCompanyAndOperatorHandle.success
  )
  .handleAction(
    fetchLabelsByCompanyAndOperatorHandle.asyncAction.failure,
    fetchLabelsByCompanyAndOperatorHandle.failure
  )
  .handleAction(resetCampaignDataAction, state => ({
    ...state,
    labels: []
  }))
